import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/search'
    },
    {
      path: '/id:id',
      name: 'user',
      component: () => import('./views/UserProfile.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('./views/Search.vue')
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return savedPosition
  }
})
